import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=7ca14674&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=7ca14674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca14674",
  null
  
)

export default component.exports